<ng-container *ngIf="isValidLicense==1">
    <div class="layout-container" dir={{isRightToLeft}}>
        <!-- ========== Left Sidebar Start ========== -->
        <ng-container *ngIf="ODataToken && showSideBar">
            <ng-container *ngIf="(this.loginService.isLoggedIn || isRefreshed) && !hide">
                <div id="menu" class="menu">
                    <app-menu></app-menu>
                </div>
            </ng-container>
        </ng-container>
        <!-- Left Sidebar End -->
        <!-- ============================================================== -->
        <!-- Start Page Content here -->
        <!-- ============================================================== -->
        <!-- Topbar Start -->
        <div class="layout-content">
            <ng-container *ngIf="ODataToken">
                <ng-container *ngIf="(this.loginService.isLoggedIn || isRefreshed) && !hide">
                    <div id="navbar-custom" class="navbar-custom">
                        <ul class="topbar-menu">
                            <li *ngIf="_userinfo.UserCode && _userinfo.UserCode != ''">
                                <chat-nav-bar></chat-nav-bar>
                            </li>
                            <li class="dropdown mx-1">
                                <app-notification></app-notification>
                            </li>
                            
                            <li class="dropdown user-list">
                                <div class="list">
                                    <a class="nav-link dropdown-toggle nav-user arrow-none" data-bs-toggle="dropdown"
                                        href="#" role="button" aria-haspopup="false" aria-expanded="false">
                                        <span class="account-user-avatar">
                                            <img src="assets/icons/account_circle_black_24dp.svg" alt="user-image"
                                                class="rounded-circle">
                                        </span>
                                        <span class="user-name">
                                            <span class="account-user-name">{{ getUserName()}}</span>
                                            <small class="account-position">{{getBusinessUnit()}}</small>
                                        </span>
                                    </a>
                                    <div
                                        class="dropdown-menu dropdown-menu-end dropdown-menu-animated topbar-dropdown-menu">
                                        <!-- item-->
                                        <div class="dropdown-header">
                                            <h6 class="text-overflow m-0">{{'Welcome'| translate}}</h6>
                                        </div>

                                        <a href="#/About" class="dropdown-item">
                                            <img src="assets/icons/about-icon.svg" class="icon-item">
                                            <span class="mx-1">{{'About'| translate}}</span>
                                        </a>

                                        <ng-container *ngIf="_userinfo.AuthType!=2">
                                            <!-- item-->
                                            <a href="#/ChangePassword" class="dropdown-item">
                                                <i class="fa-solid fa-user-pen icon-item"></i>
                                                <span class="mx-1">{{'ChangePassword'| translate}}</span>
                                            </a>
                                        </ng-container>

                                        <!-- item-->
                                        <a (click)="logout()" class="dropdown-item">
                                            <i class="fa-solid fa-arrow-right-from-bracket icon-item"></i>
                                            <span class="mx-1">{{'Logout'| translate}}</span>
                                        </a>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </ng-container>
            </ng-container>
            <ng-container *ngIf="this.loginService.isLoggedIn">
                <div class="content d-flex flex-column justify-content-between">
                    <lib-error-message></lib-error-message>
                </div>
            </ng-container>
            <div class="content content-height d-flex flex-column justify-content-between" 
            [ngClass]="{'hidecontent-page':!this.loginService.isLoggedIn || !ODataToken }">
                <ng-container *ngIf="Shared.HasAlert()">
                    <ng-container *ngFor="let alert of Shared.alerts;let indexOfAlert = index;">
                        <div [myError]="alert.type" class="accordion custom-accordion alert show mb-1" role="alert"
                            id="custom-accordion-one">
                            <div id="headingFour">
                                <a class="d-block link-headingFour" data-bs-toggle="collapse" href="#collapseFour"
                                    aria-expanded="false" aria-controls="collapseFour">
                                    <div class="row">
                                        <div class="col">
                                            <i class="fa-solid fa-circle-exclamation"></i> <strong>{{alert.type| message}}</strong>
                                        </div>
                                        <div class="col-4">
                                            <a [ngStyle]="styleErrorMsg() "
                                                (click)="Shared.closeAlert(indexOfAlert)">{{'DismissAll'| translate}}</a>
                                            <i class="fa-solid fa-chevron-down"></i>
                                        </div>
                                    </div>
                                </a>
                            </div>
                            <div id="collapseFour" class="collapse" aria-labelledby="headingFour"
                                data-bs-parent="#custom-accordion-one">
                                <ul>
                                    <li>{{alert.msg}}</li>
                                </ul>
                            </div>
                        </div>
                    </ng-container>
                </ng-container>
                <!-- end Topbar -->

                <div id="main-content-container" class="content">
                    <!-- Start Content-->
                    <div id="main-content" class="flex-row align-items-center ps-0 pe-0 justify-content-between">
                        <div>
                            <router-outlet (activate)="changeOfRoutes()"></router-outlet>
                        </div>
                        <div class="loader">
                            <ng-http-loader [extraDuration]="5" [backdrop]="true" [filteredUrlPatterns]="['login']"
                                [filteredHeaders]="['ShowLoader', 'false']" [entryComponent]="Myspinner"
                                [spinner]="spinnerStyle.skThreeBounce"></ng-http-loader>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>
<ng-container *ngIf="isValidLicense==-1">
    <app-about></app-about>
</ng-container>
<ng-container *ngIf="!isValidLicense">
    <div class="loader">
        <ng-http-loader [extraDuration]="5" [backdrop]="true" [filteredUrlPatterns]="['login']"
            [filteredHeaders]="['ShowLoader', 'false']" [entryComponent]="Myspinner"
            [spinner]="spinnerStyle.skThreeBounce"></ng-http-loader>
    </div>
</ng-container>
<!-- rightbar -->
<div class="rightbar-overlay"></div>
<div kendoDialogContainer></div>